import React from 'react';
import { Table, Input } from 'semantic-ui-react';
import { map } from 'ramda';
import { DateInput } from 'semantic-ui-calendar-react';
import { generate } from 'shortid';


const TableRow = (props) => {
  const { cols, data, onChange, rowNum } = props;

  return (
    <Table.Row>
      {
        map(({ key, defaultValue, element }) =>
            <Table.Cell key={generate()}>
                {
                  element === 'dateInput' &&
                    <DateInput
                      dateFormat='YYYY-MM-DD'
                      ix={rowNum}
                      name={key}
                      value={data[key]}
                      iconPosition="left"
                      onChange={onChange} />
                }
                {
                  element !== 'dateInput' &&
                    <Input
                      fluid
                      disabled={!!defaultValue}
                      ix={rowNum}
                      name={key}
                      value={defaultValue ? defaultValue : data[key]}
                      onChange={onChange}
                    />
                }
              </Table.Cell>
              , cols)
      }
    </Table.Row>
  );
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/private/common/components/AwsJsonTable/Row.js